import 'angular:locale/data:el';
import 'angular:locale/data:cs';
import 'angular:locale/data:da';
import 'angular:locale/data:sv';
import 'angular:locale/data:fi';
import 'angular:locale/data:tr';
import 'angular:locale/data:ro';
import 'angular:locale/data:hu';
import 'angular:locale/data:pt';
import 'angular:locale/data:pl';
import 'angular:locale/data:nl-be';
import 'angular:locale/data:fr-be';
import 'angular:locale/data:nb-no';
import 'angular:locale/data:nl';
import 'angular:locale/data:it';
import 'angular:locale/data:es';
import 'angular:locale/data:fr';
import 'angular:locale/data:en';
import 'angular:locale/data:de';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
